const moment = require('@transfeeradev/moment');

class UtilsService {
  static getFormattedDate(date) {
    if (!date) {
      date = moment();
    }

    return moment(date).format('DD/MM/YYYY');
  }

  static getFormattedDateTime(date) {
    if (!date) {
      date = moment();
    }

    return moment(date).format('DD/MM/YYYY HH:mm:ss');
  }

  static htmlToPlainText(str) {
    if (typeof str !== 'string') {
      return str;
    }

    const regex = /(<([^>]+)>)/gi;
    return str.replace(regex, '');
  }

  static getNumbersFromStr(str) {
    if (!str || typeof str !== 'string') {
      return str;
    }

    return str.replace(/[^0-9]/g, '');
  }

  static getOnlyLettersWithoutAccents(str) {
    const ONLY_LETTERS_WITHOUT_ACCENTS_REGEX = /[^a-zA-Z ]/g;
    if (typeof str !== 'string') {
      return str;
    }

    return str.replace(ONLY_LETTERS_WITHOUT_ACCENTS_REGEX, '');
  }

  static removeAccents(value) {
    if (typeof value !== 'string') {
      return value;
    }

    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  static fillZeros(value, size) {
    value = String(value);
    while (value.length < size) {
      value = '0' + value;
    }

    return value;
  }

  static removeLeadingZeros(value) {
    if (value && typeof value === 'string') {
      return value.replace(/^0+/, '').toLowerCase();
    }
    return value;
  }

  static removeNotAllowedIRSCharacters(value) {
    if (value && typeof value === 'string') {
      return value.replace(/([^A-Za-zÀ-ÖØ-öø-ÿ,.@:&*+_<>()!?/$%\d' -]+)/g, '');
    }

    return value;
  }

  static queryObjToString(query) {
    if (!query) {
      return '';
    }

    if (typeof query !== 'object') {
      throw new Error('param neet to be an object');
    }

    if (Object.keys(query).length > 0) {
      query = '?' + Object.keys(query).reduce((acc, key) => (acc += `${key}=${query[key]}&`), '');
      query = query.substring(0, query.length - 1);
    }

    return query;
  }

  static isHtmlFile(filename) {
    return (
      filename &&
      (typeof filename === 'string' || filename instanceof String) &&
      !['html', '.html'].includes(filename.trim()) &&
      filename.trim().split('.').pop() === 'html'
    );
  }
}

module.exports = UtilsService;
